export default {
  saveUser (context, payload) {
    context.commit('SAVE_USER', payload)
    // context.commit('SAVE_USER', JSON.parse(JSON.stringify(payload)))
  },
  unsetUser (context) {
    context.commit('UNSET_USER')
  },
  saveCity (context, payload) {
    context.commit('SAVE_CITY', payload)
  },
  unsetCity (context) {
    context.commit('UNSET_CITY')
  },
  saveMktpRent (context, payload) {
    context.commit('SAVE_MKTP_RENT', payload)
  },
  unsetMktpRent (context, payload) {
    context.commit('UNSET_MKTP_RENT', payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js